const StudentCredentialsCard = ({ credentials, isParent = false }) => {
  if (!credentials?.studentCode && !credentials?.pin) return null;

  return (
    <section className="student-credentials" aria-label={isParent ? "Kid credentials" : "Student credentials"}>
      <div>
        <p className="eyebrow">{isParent ? "Kid credentials" : "Student credentials"}</p>
        <h2>
          {isParent
            ? "Kid Code & Kid PIN have been sent to the kid's email."
            : "Student Code & Student PIN have been sent to the student's email."}
        </h2>
        {credentials.email && <p>{credentials.email}</p>}
      </div>
      <div className="student-credential-grid">
        <article>
          <span>{isParent ? "Kid Code" : "Student Code"}</span>
          <strong>{credentials.studentCode}</strong>
        </article>
        <article>
          <span>PIN</span>
          <strong>{credentials.pin}</strong>
        </article>
      </div>
    </section>
  );
};

export default StudentCredentialsCard;
